// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__3Bzc_","header":"styles_header__2bZRG","content":"styles_content__1dqfx","body":"styles_body__3Ojsg"};